<template>
  <div class="spinner-container" :style="{ width: size + 'px', height: size + 'px' }">
    <div
      class="spinner-inner"
      :style="{
        width: size + 'px',
        height: size + 'px',
        borderWidth: borderSize + 'px',
        borderColor: borderColor,
        borderTopColor: borderTopColor
      }"
    ></div>
  </div>
</template>

<script>
export default {
  name: 'c-spinner',
  props: {
    size: {
      type: Number,
      default: 50
    },
    borderSize: {
      type: Number,
      default: 5
    },
    borderColor: {
      type: String,
      default: '#b9b9b9'
    },
    borderTopColor: {
      type: String,
      default: '#00A4D6'
    }
  }
};
</script>




// WEBPACK FOOTER //
// Spinner.vue?2fa65fa5